import { STATUS_COLOR } from "./helpers/constants";

export const styleIconBtn = {
  background: (theme) => theme.palette.primary.main,
  borderRadius: "0.5rem",
  color: "#fff",
  "&:hover": {
    background: (theme) => theme.palette.primary.main,
    opacity: 0.7,
  },
};

export const styleInputsWrapper = (items) => ({
  display: { xs: "contents", md: "grid" },
  gridTemplateColumns: "" + items?.map((it) => "1fr").join(" ") + "",
  gridColumnGap: "0.5rem",
});

export const loaderStyle = {
  color: "#FF5733",
  "& .MuiCircularProgress-circle": { stroke: "#E0E0E0" },
};

export const styleEllipsis = {
  display: "block",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const styleTableMenuOption = {
  color: (theme) => theme.palette.primary.main,
  fontSize: "13px",
  paddingLeft: 0,
};

export const styleStatus = (val) => {
  const bg = STATUS_COLOR.find(
    (it) => it.status?.toLowerCase() === val?.toLowerCase()
  )?.color;

  return {
    padding: "0 5px",
    borderRadius: "6px",
    color: "#fff",
    background: `${bg || "rgb(145,158,171)"}`,
  };
};

export const styleButton = {
  fontWeight: 500,
  fontSize: "0.8125rem",
  lineHeight: "1.75",
  textTransform: "none !important",
};

export const styleSteps = {
  "& .MuiStepConnector-root, .MuiStepLabel-iconContainer": {
    display: "none",
  },
  justifyContent: "center",
  marginBottom: "1.5rem",
};

export const styleStepBtn = {
  "& .MuiButtonBase-root": {
    m: 0,
    p: 0,
  },
  "&.MuiStep-root": {
    padding: "0 !important",
  },
};

export const sectionLabel = {
  display: "flex",
  width: "100%",
  fontSize: "0.696429rem",
  lineHeight: 1.66,
  fontWeight: 400,
  opacity: 0.7,
  background: "#f0f8ff",
  padding: "2px",
};

export const styleQuestionLabel = {
  fontSize: "0.696429rem",
  lineHeight: 1.66,
  fontWeight: 400,
  marginLeft: "25px",
};

export const styleQuestionAnswer = {
  fontSize: "0.8125rem",
  lineHeight: 1.43,
  fontWeight: 400,
};

export const freeTierStyles = {
  display: "inline-block",
  color: "rgb(240 56 56)",
  marginBottom: "1rem",
};
